import { useContext } from "react";

import HeaderModule from "../../../components/header/HeaderModule.js";
import Loading from "../../../components/basics/Loading.js";
import ControleBuscaCard from "./children/ControleBuscaCard";
import GrupoInformacoesCard from "./children/GrupoInformacoesCard.js";
import TabelaFaturamentoCard from "./children/TabelaFaturamentoCard.js";
import { FaturamentoContratoContext } from "./contexts/FaturamentoContratoContext";
import { GlobalVariables } from "../../../GlobalVariables.js";

export default function FaturamentoContrato() {
  const { mainLoading } = useContext(FaturamentoContratoContext);

  return (
    <>
      <Loading open={mainLoading} />
      <HeaderModule
        title="FATURAMENTO DE CONTRATO ONE CLICK"
        videoId={GlobalVariables.screenVideosIds.faturamentoOneClick}
      />
      <GrupoInformacoesCard />
      <ControleBuscaCard />
      <TabelaFaturamentoCard />
    </>
  );
}
